export const getters = {
  systemPettyaccounts: state => state.pettyaccounts,
  Pettyaccount: state => state.systemPettyaccount
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/pettyaccounts/getters.js